// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import { sync } from 'vuex-router-sync'
import 'babel-polyfill';
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'IOKo153Hjmbo52lMW6VyHn1h'
})
sync(store, router)
Vue.config.productionTip = false

import httpRequest from './utils/httpRequest' 
Vue.prototype.$http = httpRequest // ajax请求方法

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import Viewer from 'v-viewer'
Vue.use(Viewer)
Viewer.setDefaults({
  zIndexInline: 9999
})

//  挂载路由守卫
// to 将访问哪一个路径
// from 代表从哪个路径跳转而来
// next 是一个函数,表示放行 
router.beforeEach((to, from, next) => {
  // 路由跳转后，让页面回到顶部
  document.body.scrollTop = 0; 
  document.documentElement.scrollTop = 0; 
  window.pageYOffset = 0; 
  //next() 放行 next('/login') 强制跳转
  // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁!!
  next();
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js